<style lang="less">
.draw-container {
  width: 750px;
  height: 100%;
  background: #f7f7f7;
  font-family: PingFangSC-Semibold;
  .detail-header {
    position: relative;
    .return-box {
      width: 100px;
      height: 100px;
      position: absolute;
      left: 24px;
      top: 36px;
      display: flex;
      align-items: center;
      z-index: 9999;
    }
    .return-box-ipx {
      width: 100px;
      height: 100px;
      position: absolute;
      display: flex;
      align-items: center;
      left: 24px;
      top: 84px;
      z-index: 9999;
    }
    .header-return {
      width: 36px;
      height: 36px;
    }
    .header-img {
      width: 750px;
      height: 270px;
    }
    .header-img-ipx {
      width: 750px;
      height: 318px;
    }
    .header-info-ipx {
      width: 750px;
      position: absolute;
      left: 0;
      top: 166px;
    }
    .header-info {
      width: 750px;
      position: absolute;
      left: 0;
      top: 118px;
    }
    .area-title {
      height: 60px;
      font-size: 44px;
      font-weight: 600;
      color: rgba(35, 44, 55, 1);
      line-height: 60px;
      text-align: center;
      margin-bottom: 18px;
    }
    .tag-box {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .tag-style {
      height: 36px;
      color: #89939F;
      border-radius: 6px;
      font-size: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      line-height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .shu{
      height: 24px;
      width: 2px;
      background: #89939F;
      margin-left: 10px;
      margin-right: 10px;
    }
  }
  .detail-main {
    padding: 0 16px;
    width: 718px;
    .detail-area-score {
      padding: 24px 24px 0;
      .detail-area-score-title {
        width: 670px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .area-score {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .score {
            height: 36px;
            line-height: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(245, 103, 11, 1);
            border-radius: 6px;
            font-size: 28px;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            margin-left: 6px;
            margin-right: 8px;
            padding: 0 10px;
            .score-img {
              width: 16px;
              height: 24px;
              margin-right: 6px;
            }
          }
          .score-info {
            width: 26px;
            height: 26px;
          }
        }
        .month-ranking {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          font-size: 26px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(35, 44, 55, 1);
          height: 36px;
          line-height: 36px;
          .ranking-title {
            color: #666666;
          }
          .ranking-level {
            color: #4588f5;
            font-weight: bold;
          }
          .ranking-all {
            color: #89939f;
          }
          .ranking-img {
            width: 10px;
            height: 16px;
            margin-left: 6px;
          }
        }
      }
      .area-score-content {
        margin: 34px 0;
        .score-box {
          padding: 8px 32px;
        }
      }
      .area-score-footer {
        height: 90px;
        border-top: 1px solid #efefef;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .area-score-footer-left {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          line-height: 36px;
          .footer-left-img {
            width: 34px;
            height: 28px;
          }
          .footer-left-text {
            height: 36px;
            font-size: 26px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(137, 147, 159, 1);
            margin-left: 14px;
          }
        }
      }
    }
    .detail-traffic {
      padding: 24px;
      margin-top: 18px;
      .traffic-count-box {
        padding: 0 48px;
        border-bottom: 2px solid #efefef;
        margin-top: 34px;
        margin-bottom: 20px;
        .traffic-count-show {
          .traffic-count {
            margin-top: 12px;
            width: 70px;
            height: 54px;
            line-height: 54px;
            text-align: center;
          }
        }
      }
      .mask-map {
        width: 100%;
        height: 100%;
      }
    }
    .village {
      padding: 24px;
      margin-top: 18px;
      .village-box-wrapper {
        margin: 34px 66px 40px;
        .village-name {
          margin-bottom: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .village-img-box {
          width: 35px;
          width: 35px;
          text-align: center;
          line-height: 26px;
          .village-img {
            width: 26px;
            height: 26px;
          }
        }
      }
      .village-progress {
        margin-top: 10px;
        .progress-title {
          float: left;
          width: 170px;
          height: 60px;
          font-size: 26px;
          color: rgba(137, 147, 159, 1);
          line-height: 60px;
          text-align: right;
        }
        .progress_wrapper {
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
        .progress {
          width: 466px;
          height: 26px;
          color: #f5a623;
          border-radius: 14px;
        }
        .van-progress {
          background: #f7f7f7;
        }
        .van-progress__portion--with-pivot {
          border-radius: 14px;
        }
      }
    }
    .company {
      padding: 24px 24px 0;
      margin-top: 18px;
      .company-box-wrapper {
        margin: 34px 50px;
      }
      .company-footer {
        border-top: 1px solid #efefef;
        height: 90px;
        display: flex;
        justify-content: flex-end;
      }
    }
    .industry-development {
      padding: 24px 24px 60px;
      margin-top: 18px;
      .development-box-wrapper {
        margin: 34px 100px 0;
      }
      .development-echarts {
        position: relative;
        width: 670px;
        height: 600px;
        ec-canvas {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }
      }
      .development-dec {
        // height:36px;
        font-size: 26px;
        color: rgba(35, 44, 55, 1);
        line-height: 36px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .dec-dian {
          font-weight: bold;
          margin-right: 10px;
        }
      }
    }
  }
  .detail-footer {
    height: 102px;
    line-height: 102px;
    text-align: center;
    color: #BDC3CE;
    font-size: 26px;
  }

.title {
  font-size: 32px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(35, 44, 55, 1);
  line-height: 44px;
  text-align: left;
}
.subhead {
  height: 36px;
  font-size: 26px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: #232c37;
  line-height: 36px;
  text-align: left;
}
.footer-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .footer-right-img {
    width: 14px;
    height: 18px;
  }
  .footer-right-text {
    height: 36px;
    font-size: 26px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(65, 105, 225, 1);
    line-height: 36px;
    margin-right: 4px;
  }
}
.common-box-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .common-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .common-title {
      height: 36px;
      font-size: 26px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(137, 147, 159, 1);
      line-height: 36px;
      margin-bottom: 10px;
    }
    .common-info {
      height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      line-height: 44px;
    }
  }
}
.main-wrapper {
  background: #fff;
  width: 670px;
  box-shadow: 0px 0px 4px 0px rgba(219, 219, 219, 0.5);
  border-radius: 6px;
}
#detail_map {
  width: 100%;
  height: 308px;
}
.van-popup {
  border-radius: 8px;
  width: 560px;
}
.popup-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 22px 38px 40px;
  // height: 656px;
  // overflow-y: scroll;
  .dialog-title {
    height: 44px;
    font-size: 32px;
    color: rgba(35, 44, 55, 1);
    line-height: 44px;
    margin: 16px 0;
    font-weight: bold;
  }
  .dialog-info {
    text-align: left;
    font-size: 28px;
    color: rgba(111, 120, 132, 1);
    line-height: 40px;
  }
}
.modal-btn-wrapper {
  display: flex;
  flex-direction: row;
  height: 100px;
  line-height: 100px;
  border-top: 2px solid rgba(7, 17, 27, 0.1);
  background: #fff;
}
.confirm-btn {
  flex: 1;
  height: 90px;
  line-height: 90px;
  text-align: center;
  font-size: 32px;
}
.selected {
  color: #4169e1;
  border-bottom: 2px solid #4169e1;
}
}
</style>
<template>
  <div class="draw-container">
    <div class="detail-header">
      <!-- <div :class="isIpx?'return-box-ipx':'return-box'" @click="returnPre">
        <img class="header-return" src="../../assets/img/return.png">
      </div>-->
      <img :class="isIpx?'header-img-ipx':'header-img'" src="../../assets/img/buss-background.png">
      <div :class="isIpx?'header-info-ipx':'header-info'">
        <div class="area-title">目标商圈</div>
        <div class="tag-box">
          <div class="tag-style">包含商圈：</div>
          <div class="tag-style" v-for="(item,index) in tagList" :key="index">
            {{item}}
            <div class="shu" v-if="index!=tagList.length-1"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-main">
      <div class="detail-area-score main-wrapper">
        <div class="detail-area-score-title">
          <div class="area-score">
            <div class="title">区域得分</div>
            <div class="score">
              <img class="score-img" src="../../assets/img/score.png">
              <label>{{scoreInfo.score}}分</label>
            </div>
            <img class="score-info" @click="lookScore" src="../../assets/img/wenhao.png">
          </div>
        </div>
        <div class="area-score-content common-box-wrapper">
          <div class="score-box common-box">
            <div class="score-title common-title">月租金</div>
            <div class="area-score-info common-info">{{zoneDetail.unitRentPrice}}元/平米</div>
          </div>
          <div class="score-box common-box">
            <div class="score-title common-title">挂牌量</div>
            <div class="area-score-info common-info">{{zoneDetail.houseNum}}</div>
          </div>
          <div class="score-box common-box">
            <div class="score-title common-title">挂牌周期</div>
            <div class="area-score-info common-info">{{zoneDetail.activeDate}}天</div>
          </div>
        </div>
        <div class="area-score-footer">
          <div class="area-score-footer-left">
            <img class="footer-left-img" src="../../assets/img/hzf-log.png">
            <div class="footer-left-text">会找房商业决策应用中心</div>
          </div>
          <div class="footer-right" v-debounce="goMarketPrice">
            <div class="footer-right-text">详细市场分析</div>
            <img class="footer-right-img" src="../../assets/img/right.png">
          </div>
        </div>
      </div>
      <div class="detail-traffic main-wrapper">
        <div class="title">交通配套</div>
        <div class="traffic-count-box common-box-wrapper">
          <div
            class="traffic-count-show common-box"
            v-for="(item,index) in trafficList"
            :key="index"
            @click="selectTraffic(item,index)"
          >
            <div class="traffic-name common-title">{{item.name}}</div>
            <div class="traffic-count common-info"
              :style="index==currentIndex?'color:#4169e1;border-bottom: 1px solid #4169e1;':''"
            >{{item.value}}</div>
          </div>
        </div>
        <div id="detail_map" v-debounce="goTraffic"></div>
      </div>
      <div class="village main-wrapper">
        <div class="title">小区</div>
        <div class="village-box-wrapper common-box-wrapper">
          <div
            class="village-box common-box"
            v-for="(item,index) in villageList"
            :key="index"
            @click.stop="goVillageList(item,index)"
          >
            <div class="village-name common-title">
              <label>{{item.name}}</label>
              <div class="village-img-box" @click.stop="whatVillage">
                <img v-if="index==1" class="village-img" src="../../assets/img/wenhao.png">
              </div>
            </div>
            <div class="village-count common-info" style="color:#4169E1;font-weight:bold;">{{item.count}}</div>
          </div>
        </div>
        <div class="subhead">小区规模分布</div>
        <div class="village-progress" v-for="(item,index) in progressList" :key="index">
          <div class="progress-title">{{item.name}}</div>
          <div class="progress_wrapper">
            <Progress
              class="progress"
              :percentage="item.value<=30?item.value*3:item.value>30&&item.value<50?item.value*2:item.value>50&&item.value<75?item.value*1.5:item.value"
              :pivot-text="item.value?item.value+'%':0+'%'"
              text-color="#F5A623"
              pivot-color="rgba(255,255,255,0)"
              color="#F5A623"
            />
          </div>
        </div>
      </div>
      <div class="company main-wrapper">
        <div class="title">企业</div>
        <div class="company-box-wrapper common-box-wrapper">
          <div class="company-box common-box" v-for="(item,index) in companyList" :key="index">
            <div class="company-title common-title">{{item.name}}</div>
            <div class="company-info common-info">{{item.count}}</div>
          </div>
        </div>
        <div class="company-footer">
          <div class="footer-right" v-debounce="goCompanyDetails">
            <div class="footer-right-text">企业及岗位分析</div>
            <img class="footer-right-img" src="../../assets/img/right.png">
          </div>
        </div>
      </div>
      <div class="industry-development main-wrapper">
        <div class="title">行业发展</div>
        <div class="development-box-wrapper common-box-wrapper">
          <div class="development-box common-box">
            <div class="development-title common-title">中介公司</div>
            <div class="development-info common-info">{{developmentInfo.agencyNum}}</div>
          </div>
          <div class="development-box common-box">
            <div class="development-title common-title">经纪人</div>
            <div class="development-info common-info">{{developmentInfo.brokerNum}}</div>
          </div>
        </div>
        <div class="development-echarts" v-if="pieData.length>0">
          <div ref="detailPie" style="height: 100%"></div>
        </div>
        <div style="text-align:center;margin:20px 0;" v-else>暂无数据</div>
        <div class="development-dec" v-if="apartmentInfo.length>0">
          <div class="dec-dian">·</div>
          <div class="dec-info">
            已入驻明星品牌公寓：
            <label
              v-for="(item,index) in apartmentInfo"
              :key="index"
            >{{item}}{{index==apartmentInfo.length-1?'':'、'}}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-footer">收房会选址 · 出房不发愁</div>
    <van-popup v-model="show">
      <div class="popup-box">
        <div class="dialog-title">选址评分</div>
        <div
          class="dialog-info"
        >选址评分是业务团队深入了解合作商家，进行实地探访，将其在长租行业的选址经验整合沉淀、量化各类信息维度，经算法分析形成的结果。选址评分主要通过对城市配套和市场表现两个方面进行评估，满分为100分，得分越高，越适合长租公寓运营商收房选址。</div>
        <div class="dialog-title">评分维度说明</div>
        <div
          class="dialog-info"
        >城市配套是指区域范围内的居住条件，包括内部小区品质、周边的交通、生活配套，以及企业和职工密集度等市场表现是指该区域的租房市场体量、实际需求量，和长租市场发展潜力等</div>
      </div>
      <div class="modal-btn-wrapper">
        <div class="confirm-btn" style="color:#4169E1" @click="confirmPopup">知道了</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
let timestampStart, timestampEnd;
var map;
import { Progress, Dialog, Popup, Toast } from "vant";
export default {
  name: "detail",
  components: {
    Progress,
    "van-popup": Popup
  },
  data() {
    return {
      isIpx: false,
      show: false,
      pieData: [],
      tagList: [],
      trafficList: [],
      currentIndex: 0,
      latitude: 40.072029,
      longitude: 116.360235,
      markers: [],
      trafficName: "",
      scale: 14,
      polygons: [],
      villageList: [
        {
          name: "小区总数",
          count: ""
        },
        {
          name: "近地铁小区",
          count: ""
        },
        // {
        //   name: "近半年新小区",
        //   count: ""
        // }
      ],
      companyList: [
        {
          name: "公司总数",
          count: ""
        },
        {
          name: "在招岗位数",
          count: ""
        },
        {
          name: "平均工资",
          count: ""
        }
      ],
      companyInfo: {},
      apartmentInfo: [],
      zoneDetail: {},
      scoreInfo:{},
      progressList: [],
      developmentInfo: {},
      isShare: 0,
      zoneId: 0,
      cityId: 0,
      polyline:'',
      communityIds:''
    };
  },
  directives: {
   debounce: {
    inserted: function (el, binding) {
     let timer
     el.addEventListener('click', () => {
      if (timer) {
       clearTimeout(timer)
      }
      timer = setTimeout(() => {
       binding.value()
      }, 500)
     })
    }
   }
  },
  created() {
    timestampStart = new Date().getTime();
    this.addBuried({
      source:'1',
      eventType: '曝光事件',
      eventContent: '区域详情'
    });
    let options = this.$route.query;
    this.latitude = options.latitude;
    this.longitude = options.longitude;
    this.polyline = options.polyline;
    this.cityId = options.cityId;
    if (typeof options.bizNames == 'string') {
      this.tagList.push(options.bizNames)
    }else{
      this.tagList = options.bizNames;
    }
    this.communityIds = options.communityIds;
    this.getZoneDetail();
    this.getDrawScoreDetail();
    this.getVillageInfo();
    this.getCompanyInfo();
    this.getApartmentInfo();
  },
  mounted() {
    this.onReachBottom(e=>{
      this.addBuried({
        source:'1',
        eventType: '触底事件',
        eventContent: '区域详情'
      });
    });
    map = new BMap.Map("detail_map");
    var point = new BMap.Point(this.longitude, this.latitude);
    map.centerAndZoom(point, 14);
    map.disableDragging();
    map.disableDoubleClickZoom();
    map.disableScrollWheelZoom();
    map.disablePinchToZoom();
    this.getDevelopmentInfo();
    this.getTrafficInfo();
    this.getThisPolyline();
  },
  methods: {
    createPie() {
      let dom = this.$refs["detailPie"];
      let myChart = this.$echarts.init(dom);
      let option = '';

      option = {
        backgroundColor: "#ffffff",
        color: [
          "#698EFF",
          "#FF8E55",
          "#9785ED",
          "#FFCC5C",
          "#FF7B74",
          "#4ACAA8",
          "#D7A4F6",
          "#FAEE00",
          "#64CCFF",
          "#E89242",
          "#FF76AE",
          "#8DE034"
        ],
        title: {
          text: "中介公司\n房源规模分布",
          // x 设置水平安放位置，默认左对齐，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
          x: "center",
          // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
          y: "center",
          backgroundColor: "rgba(255,255,255,0)",
          // 主标题文本样式设置
          textStyle: {
            fontSize: 12,
            height: 19,
            lineHeight: 19,
            color: "#111111"
          }
        },
        series: [
          {
            name: "",
            minAngle: 30,
            avoidLabelOverlap: false,
            label: {
              fontSize: 14,
              formatter: "{b|{b}}\n{a|{d}%}",
              borderWidth: 20,
              borderRadius: 4,
              padding: [0, -75],
              rich: {
                a: {
                  color: "#333",
                  fontSize: 10,
                  lineHeight: 14,
                  align: "left"
                },
                b: {
                  fontSize: 10,
                  lineHeight: 14,
                  color: "#333",
                  align: "left"
                }
              }
            },
            type: "pie",
            center: ["50%", "50%"],
            radius: ["35%", "45%"],
            labelLine: {
              normal: {
                length: 15,
                length2: 75
              }
            },
            data: this.pieData,
            itemStyle: {
              normal: {
                borderWidth: 2,
                borderColor: "#fff"
              },
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 2, 2, 0.3)"
              }
            }
          }
        ]
      };
      if (option && typeof option === "object") {
        myChart.setOption(option, true);
      }
    },
    //返回上个页面
    returnPre() {
      if (this.isShare == 0) {
        wx.navigateBack({
          delta: 1
        });
      } else {
        wx.reLaunch({
          url: "/pages/home/index"
        });
      }
    },
    //查看评分标准
    lookScore() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "查看评分标准"
      });
      this.show = true;
    },
    confirmPopup() {
      this.show = false;
    },
    //近地铁小区弹窗
    whatVillage() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "查看近地铁小区标准"
      });
      Dialog.alert({
        title: "近地铁小区",
        message: "距离地铁站直线距离2000米以内",
        confirmButtonText: "知道了"
      }).then(() => {
        // on close
      });
    },
    //跳转小区列表
    goVillageList(item, index) {
      let title = "";
      if (item.count == 0) {
        if (index == 0) {
          title = "暂无小区";
        } else if (index == 1) {
          title = "暂无附近地铁小区";
        } else {
          title = "暂无近半年新小区";
        }
        Toast(title);
      } else {
        let isNearSubway,url;
        if (index == 0) {
          this.addBuried({
            source: "1",
            eventType: "点击事件",
            eventContent: "小区列表_小区总数"
          });
          url = "/pages/draw_village_list/index?communityIds=" +
                this.communityIds +
                "&cityId="+item.cityId
        } else if (index == 1) {
          this.addBuried({
            source: "1",
            eventType: "点击事件",
            eventContent: "小区列表_近地铁小区"
          });
          url = "/pages/draw_village_list/index?communityIds=" +
                this.communityIds +
                "&cityId="+item.cityId+
                "&isNearSubway=1"
          isNearSubway = 1
        } else {
          this.addBuried({
            source: "1",
            eventType: "点击事件",
            eventContent: "小区列表_近半年新小区"
          });
        }
        this.isMiniProgram(res => {
          if (res) {
            wx.miniProgram.navigateTo({
              url:url
            });
          } else {
            this.$router.push({
              path: "/draw_village_list",
              query: {
                communityIds: this.communityIds,
                cityId:this.cityId,
                isNearSubway:isNearSubway==1?1:''
              }
            });
          }
        });
      }
    },
    //跳转市场量价分析页
    goMarketPrice() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "跳转市场量价分析页"
      });
      this.isMiniProgram(res => {
          if (res) {
            wx.miniProgram.navigateTo({
              url:
                "/pages/draw_market_price/index?communityIds=" +
                this.communityIds +
                "&latitude=" +
                this.latitude +
                "&longitude=" +
                this.longitude +
                "&cityId=" +
                this.cityId
            });
          } else {
            this.$router.push({
              path: "/draw_market_price",
              query: {
                cityId: this.cityId,
                communityIds: this.communityIds,
                latitude: this.latitude,
                longitude: this.longitude
              }
            });
          }
        });
    },
    //跳转交通配套
    goTraffic() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "跳转交通配套"
      });
      this.isMiniProgram(res => {
          if (res) {
            wx.miniProgram.navigateTo({
              url:
                "/pages/draw_traffic_matching/index?polyline=" +
                this.polyline +
                "&latitude=" +
                this.latitude +
                "&longitude=" +
                this.longitude +
                "&name=" +
                this.trafficName +
                "&currentIndex=" +
                this.currentIndex +
                "&cityId=" +
                this.cityId
            });
          } else {
           this.$router.push({
              path: "/draw_traffic_matching",
              query: {
                currentIndex: this.currentIndex,
                polyline: this.polyline,
                latitude: this.latitude,
                longitude: this.longitude,
                name: this.trafficName,
                cityId:this.cityId
              }
            });
          }
        });
    },
    //跳转企业详情
    goCompanyDetails() {
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({url: '/pages/draw_company_details/index?polyline='+this.polyline});
        } else {
          this.$router.push({
            path: "/draw_company_details",
            query: { polyline: this.polyline }
          });
        }
      });
    },
    //交通配套选择
    selectTraffic(item, index) {
      this.currentIndex = index;
      this.trafficName = item.name;
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: item.name
      });
      this.getTrafficDetail(item.name);
    },
    //获取交通汇总信息
    async getTrafficInfo() {
      await this.$axios
        .post("api/xz/draw/traffic/sum/", {
          polyline: this.polyline,
          cityId:this.cityId
        })
        .then(res => {
          if (res.success) {
            let list = res.result;
            this.trafficList = list;
            this.trafficName = this.trafficList[0].name;
            this.getTrafficDetail(this.trafficList[0].name, 1);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取交通配套详情信息
    async getTrafficDetail(name, isFirst) {
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner"
      });
      await this.$axios
        .post("api/xz/draw/traffic/info/", {
          cityId:this.cityId,
          polyline: this.polyline,
          name: name
        })
        .then(res => {
          if (res.success) {
            map.clearOverlays();
            if (res && res.result && res.result.list) {
              let trafficDetailList = res.result.list;
              let len = trafficDetailList.length;
              for (let i = 0; i < len; i++) {
                var marker = new BMap.Marker(
                  new BMap.Point(
                    trafficDetailList[i].longitude,
                    trafficDetailList[i].latitude
                  )
                );
                map.addOverlay(marker);
              }
            }
          }
          Toast.clear();
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取指标信息
    async getZoneDetail() {
      await this.$axios
        .post("api/xz/draw/index/", {
          communityIds: this.communityIds
        })
        .then(res => {
          if (res.success) {
            this.zoneDetail = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取得分信息
    async getDrawScoreDetail(){
      await this.$axios
        .post("api/xz/draw/zone/sum/", {
          communityIds:this.communityIds,
          cityId:this.cityId
        })
        .then(res => {
          if (res.success) {
            this.scoreInfo = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取小区汇总信息
    async getVillageInfo() {
      await this.$axios
        .post("api/xz/draw/community/sum/", {
          communityIds: this.communityIds
        })
        .then(res => {
          if (res.success) {
            if (res && res.result && res.result.list) {
              this.villageList[0].count = res.result.totalNum;
              this.villageList[1].count = res.result.nearSubwayNum;
              // this.villageList[2].count = res.result.newNum;
              this.progressList = res.result.list;
              for (let i = 0; i < this.progressList.length; i++) {
                if (this.progressList[i].value==0) {
                  this.progressList[i].value=0;
                }else{
                  this.progressList[i].value = Number((
                    (this.progressList[i].value / res.result.totalNum) *
                    100
                  ).toFixed(2));
                }
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取企业汇总信息
    async getCompanyInfo() {
      await this.$axios
        .post("api/xz/draw/enterprise/sum/", {
          polyline: this.polyline
        })
        .then(res => {
          if (res.success) {
            this.companyList[0].count = res.result.enterpriseNum;
            this.companyList[1].count = res.result.employeeNum;
            this.companyList[2].count = res.result.averagePay + "元";
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取品牌公寓信息
    async getApartmentInfo() {
      await this.$axios
        .post("api/xz/draw/brand/list/", {
          communityIds: this.communityIds,
          cityId:this.cityId
        })
        .then(res => {
          if (res.success) {
            this.apartmentInfo = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取行业发展信息
    async getDevelopmentInfo() {
      await this.$axios
        .post("api/xz/draw/industry/pie/", {
          communityIds: this.communityIds
        })
        .then(res => {
          if (res.success) {
            this.developmentInfo = res.result;
            this.pieData = res.result.pie;
            setTimeout(() => {
              this.createPie();
            }, 500);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取当前商圈描边信息
    async getThisPolyline() {
      let coordinateList = JSON.parse(localStorage.getItem('drawList')); 
      let len = coordinateList.length;
      let arr = [];
      for (let i = 0; i < len; i++) {
        arr.push(
          new BMap.Point(
            coordinateList[i].lng,
            coordinateList[i].lat
          )
        );
      }
      var polygon = new BMap.Polygon(arr, {
        strokeColor: "#4169E1",
        strokeStyle: "dashed",
        fillColor: "#4169E1",
        strokeWeight: 3,
        strokeOpacity: 1,
        fillOpacity: 0.1
      });
      polygon.disableMassClear();
      map.addOverlay(polygon);
    }
  },
  destroyed() {
    timestampEnd = new Date().getTime();
    let residenceTime = timestampEnd - timestampStart;
    this.addBuried({
      source:'1',
      eventType: '页面停留时长',
      eventContent: '区域详情停留时长'+residenceTime/1000+'s'
    });
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/region_detail/index.vue